import {
    REQUEST_EVENT_DATA,
    RECEIVE_EVENT_DATA,
    REQUEST_DOWNLOAD_FILE,
    RECEIVE_DOWNLOAD_FILE,
    OPERATION_ERROR
} from '../../constants/action_types';

import { GetAllEventLogs, DownloadFileAddress } from '../../constants/apiService';

export const requestEventLogs = (filter) => {
    return {
        type: REQUEST_EVENT_DATA,
        fetchConfig:
        {
            address: GetAllEventLogs,
            method: 'POST',
            success: recieveEventData,
            body: filter,
            showGlobalProgress: true,
            failure: operationErrored
        }
    };
};
export const recieveEventData = result => {
    return {
        type: RECEIVE_EVENT_DATA,
        result: result
    };
};

export const requestDownloadFile = (blobPath, timeStamp) => {
    return {
        type: REQUEST_DOWNLOAD_FILE,
        fetchConfig: {
            address: DownloadFileAddress + blobPath,
            method: 'GET',
            success: receiveDownloadFile,
            download: true,
            fileName: 'EventLogs_' + timeStamp,
            fileExtention: '.json',
            failure: operationErrored,
            showGlobalProgress: false
        }
    };
};

export const receiveDownloadFile = result => {
    return {
        type: RECEIVE_DOWNLOAD_FILE,
        result: result
    };
};

export const operationErrored = error => {
    return {
        type: OPERATION_ERROR,
        Error: error
    };
};
